/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Knee_HelpInputs */

const en_audio_description_export_automix_knee_help = /** @type {(inputs: Audio_Description_Export_Automix_Knee_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smoothness of transition (higher = smoother ducking). 2-4dB Knee recommended.`)
};

const fr_audio_description_export_automix_knee_help = /** @type {(inputs: Audio_Description_Export_Automix_Knee_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Douceur de transition (plus élevé = plus doux). Genou 2-4 dB recommandé.`)
};

const de_audio_description_export_automix_knee_help = /** @type {(inputs: Audio_Description_Export_Automix_Knee_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanfter Übergang (höherer Wert = sanfteres Ducken). 2–4 dB Knie empfohlen.`)
};

const it_audio_description_export_automix_knee_help = /** @type {(inputs: Audio_Description_Export_Automix_Knee_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluidità di transizione (più alto = ducking più fluido). Si consiglia un ginocchio da 2 a 4 dB.`)
};

const ru_audio_description_export_automix_knee_help = /** @type {(inputs: Audio_Description_Export_Automix_Knee_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Плавность перехода (чем выше уровень, тем плавнее приглушение звука). Рекомендуется уровень «колена» 2-4 дБ.`)
};

const es_audio_description_export_automix_knee_help = /** @type {(inputs: Audio_Description_Export_Automix_Knee_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suavidad de transición (cuanto más alto, más suave el efecto). Se recomienda un valor de rodilla de 2-4 dB.`)
};

const zh_cn2_audio_description_export_automix_knee_help = /** @type {(inputs: Audio_Description_Export_Automix_Knee_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过渡平滑度（数值越高，闪避越平滑）。建议膝盖高度设置为 2-4dB。`)
};

const ja_audio_description_export_automix_knee_help = /** @type {(inputs: Audio_Description_Export_Automix_Knee_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遷移の滑らかさ (値が高いほどダッキングがスムーズになります)。2 ～ 4 dB のニーを推奨します。`)
};

const hi_audio_description_export_automix_knee_help = /** @type {(inputs: Audio_Description_Export_Automix_Knee_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तन की सुगमता (उच्चतर = अधिक सुगम डकिंग)। 2-4dB नी की अनुशंसा की जाती है।`)
};

const pt_pt2_audio_description_export_automix_knee_help = /** @type {(inputs: Audio_Description_Export_Automix_Knee_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suavidade da transição (quanto maior, mais suave a atenuação). Recomenda-se um joelho de 2 a 4 dB.`)
};

/**
* | output |
* | --- |
* | "Smoothness of transition (higher = smoother ducking). 2-4dB Knee recommended." |
*
* @param {Audio_Description_Export_Automix_Knee_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_knee_help = /** @type {((inputs?: Audio_Description_Export_Automix_Knee_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Knee_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_automix_knee_help(inputs)
	if (locale === "de") return de_audio_description_export_automix_knee_help(inputs)
	if (locale === "it") return it_audio_description_export_automix_knee_help(inputs)
	if (locale === "ru") return ru_audio_description_export_automix_knee_help(inputs)
	if (locale === "es") return es_audio_description_export_automix_knee_help(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_automix_knee_help(inputs)
	if (locale === "ja") return ja_audio_description_export_automix_knee_help(inputs)
	if (locale === "hi") return hi_audio_description_export_automix_knee_help(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_automix_knee_help(inputs)
	return en_audio_description_export_automix_knee_help(inputs)
});